<template>
  <div id="not-found">
    <div class="number">
      404
    </div>
    <div class="title">
      Not Found
    </div>
    <div class="text">
      This page does not exist
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFound'
}
</script>

<style scoped>
#not-found {
  text-align: center;
  margin-top: 6em;
}
.number {
  font-size: 10em;
}
.title {
  font-size: 5em;
}
.text {
  margin-top: 1em;
  font-size: 2em;
}
</style>
